<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: Mindy Kim, Class President, by Lyla Lee, illustrated by Dung Ho" class="imagefp" epub:type="cover" role="doc-cover" src="e9781534440180/images/9781534440180.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?4bcfd837